import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import SectionHeading from "@/components/base/SectionHeading";

export default function DigestSection() {
  const recap = articles.find((a) => a.category === "gossip") ?? articles[0];
  const weekList = [...articles].sort((a, b) => b.date.localeCompare(a.date)).slice(0, 5);

  return (
    <section id="digest" className="scroll-mt-28 border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading eyebrow="Weekly" title="每周盘点" description="一周话题脉络梳理，把零散的热点串成一条看得懂的时间线。" />

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <article className="lg:col-span-7">
            <div className="h-56 w-full overflow-hidden rounded-lg md:h-72">
              <img
                src={recap.cover}
                alt={`${recap.title} · 瓜网每周盘点`}
                title={`${recap.title} · 瓜网${recap.categoryName}`}
                className="h-full w-full object-cover object-top"
              />
            </div>
            <span className="mt-5 inline-block rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
              本周主话题
            </span>
            <h3 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950">
              <Link to={`/article/${recap.slug}`} className="hover:text-primary-700">
                {recap.title}
              </Link>
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700">{recap.excerpt}</p>
            <Link
              to={`/article/${recap.slug}`}
              className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              阅读完整复盘
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </article>

          <aside className="lg:col-span-5">
            <h3 className="mb-4 border-b border-background-200 pb-3 font-heading text-lg font-bold text-foreground-950">
              本周热度前五
            </h3>
            <ol className="space-y-4">
              {weekList.map((article, index) => (
                <li key={article.slug} className="flex gap-4">
                  <span className="font-heading text-xl font-bold text-secondary-600">
                    {index + 1}
                  </span>
                  <div className="min-w-0">
                    <h4 className="font-heading text-sm font-bold leading-snug text-foreground-900">
                      <Link to={`/article/${article.slug}`} className="hover:text-primary-700">
                        {article.title}
                      </Link>
                    </h4>
                    <p className="mt-1 text-xs text-foreground-500">
                      {article.categoryName} · {article.date}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          </aside>
        </div>
      </div>
    </section>
  );
}